import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface BrokerInformationAddEditDialogProps {
  open: boolean
  onClose: () => void
  onSave: (values: any) => void
}

export default function BrokerInformationAddEditDialog({ open, onClose, onSave }: BrokerInformationAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={{}}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={{}}
        onSubmit={values => {
          onSave(values)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Broker Information</DialogTitle>

                  <Grid item xs={12} sm={12}>
                    <Typography variant='body1' color='secondary'>
                      <strong style={{ color: 'red' }}>
                        Click Edit in Addresses Card Email is required. <br />
                        Click Edit in Addresses Card Phone Number is required. <br /> Click Edit in Addresses Card
                      </strong>
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <ExplanationAccordion>||All fields are required. ||</ExplanationAccordion>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <Button type='submit' variant='contained'>
                  SAVE
                </Button>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
